import React, { useEffect, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import { Form, Formik } from "formik";
import { FtextField } from "../../components/common/FtextField";
import Loader from "../../components/common/Loader";
import useDataInputOption from "../../hooks/useDataInputOption";
import { adminSubmit, adminUpdateSubmit } from "../../features/apiCallAdmin";
import { useDispatch } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";

const AdminDialog = ({ show, setShow, isUpdate, admin }) => {
  const dispatch = useDispatch();

  const inputPermission = {
    name: true,
    mobile: true,
    status: true,
  };

  const permission = [
    {
      label: "Dashboard",
      value: "dashboard",
      isChecked: admin?.permission?.dashboard ?? false,
    },
    {
      label: "Invoice",
      value: "invoice",
      isChecked: admin?.permission?.invoice ?? false,
    },
    {
      label: "ISP Owner details",
      value: "ispOwnerDetails",
      isChecked: admin?.permission?.ispOwnerDetails ?? false,
    },
    {
      label: "ISP Owner invoice create",
      value: "createInvoice",
      isChecked: admin?.permission?.createInvoice ?? false,
    },
    {
      label: "ISP Owner invoice update",
      value: "updateInvoice",
      isChecked: admin?.permission?.updateInvoice ?? false,
    },
    {
      label: "ISP Owner package update",
      value: "updatePackage",
      isChecked: admin?.permission?.updatePackage ?? false,
    },
    {
      label: "ISP Owner permission update",
      value: "updatePermission",
      isChecked: admin?.permission?.updatePermission ?? false,
    },
    {
      label: "ISP Owner multiple customer update",
      value: "updateMultipleCustomer",
      isChecked: admin?.permission?.updateMultipleCustomer ?? false,
    },
    {
      label: "ISP Owner CSV upload",
      value: "csvUpload",
      isChecked: admin?.permission?.csvUpload ?? false,
    },
    {
      label: "ISP Owner password reset",
      value: "passwordReset",
      isChecked: admin?.permission?.passwordReset ?? false,
    },
  ];

  //---> Get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(
    inputPermission,
    null,
    "post",
    isUpdate ? admin : null
  );

  //---> Loading State
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState(permission);

  const adminPermissionHandler = (e) => {
    const { name, checked } = e.target;

    let temp = [...permissions];

    if (name === "allPermissions") {
      temp = temp.map((val) => ({ ...val, isChecked: checked }));
    } else {
      temp = temp.map((val) =>
        val.value === name ? { ...val, isChecked: checked } : val
      );
    }

    setPermissions(temp);
  };

  const handleAdminSubmit = (formValues) => {
    const permissionData = {};
    permissions.forEach((item) => {
      permissionData[item.value] = item.isChecked;
    });

    const sendData = {
      ...formValues,
      permission: permissionData,
    };

    if (isUpdate) {
      adminUpdateSubmit(dispatch, admin?._id, sendData, setIsLoading, setShow);
    } else {
      adminSubmit(dispatch, sendData, setIsLoading, setShow);
    }
  };

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={false}
        size={"md"}
        header="Create new admin"
      >
        <Formik
          initialValues={{
            ...dataInputOption?.inputInitialValues,
          }}
          validationSchema={dataInputOption?.validationSchema}
          onSubmit={(values) => {
            handleAdminSubmit(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form>
              <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="profile" title="Profile">
                  <div className="displayGrid">
                    {dataInputOption?.inputOption.map(
                      (item) => item?.isVisible && <FtextField {...item} />
                    )}
                  </div>
                </Tab>

                <Tab eventKey="permission" title="Permission">
                  <div className="displayGrid">
                    <div className="CheckboxContainer">
                      <input
                        type="checkbox"
                        className="CheckBox"
                        name="allPermissions"
                        onChange={adminPermissionHandler}
                        id="selectAllPermissions"
                        checked={permissions.every((item) => item.isChecked)}
                      />
                      <label
                        htmlFor="selectAllPermissions"
                        className="checkboxLabel text-info fw-bold"
                      >
                        All Permission
                      </label>
                    </div>

                    {permissions.map((val, key) => (
                      <div
                        className="CheckboxContainer d-flex justify-content-between"
                        key={key}
                      >
                        <div>
                          <input
                            type="checkbox"
                            className="CheckBox"
                            name={val.value}
                            checked={val.isChecked}
                            onChange={adminPermissionHandler}
                            id={val.value + key}
                          />
                          <label
                            htmlFor={val.value + key}
                            className="checkboxLabel"
                          >
                            {val.label}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </Tab>
              </Tabs>

              <div className="displayGrid1 float-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={isLoading}
                  onClick={() => setShow(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success customBtn"
                  disabled={isLoading}
                >
                  {isLoading ? <Loader /> : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default AdminDialog;
